import { Injectable } from '@angular/core';

@Injectable()
export class CommonService {
  developmentPort = '4200';
  servicesPort = '8080';
  developmentProtocol = 'http';
  contextName = 'cela/';


  gmailUserName= '';
  gmailUserPassword= '';
  body= 'Su contraseña asignada es ';
  subject= 'Contraseña del sistema';
  isBodyHtml = 'false';

  public getDataEmail(): any {
    const dataMail ={
      GmailUserAddress: this.gmailUserName,
      GmailUserPassword:this.gmailUserPassword,
      Body: this.body,
      Subject: this.subject,
      IsBodyHtml: this.isBodyHtml,
      EmailTo:[],
      CcTo:[]
    }
    return dataMail;
  }

  constructor() { }

  public getPrefixUrlService(): string {

    //const prefix = 'http://localhost:57960/';
    const prefix = 'http://www.trackingarea.com:8081/';
    return prefix;
  }

  private getCurrentUser(): any {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser;
  }

  public getUserName(): string {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      return currentUser.userAccount;
    } else {
      return '';
    }
  }

  public getUserPass(): string {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      return currentUser.totalInPass;
    } else {
      return '';
    }
  }

  public getUserRole(): string {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      return currentUser.userRole;
    } else {
      return '';
    }
  }

  getNameUser(): string {
    return this.getCurrentUser().user_account;
  }


}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/common.service.ts